import { IGenerateOptionsArgs } from './interfaces';
import { defaultOptions } from '../constants/defaultOptions';
import generateChart from './chart/generateChart';
import generateLegend from './legend/generateLegend';
import generatePlotOptions from './plotOptions/generatePlotOptions';
import generateSeries from './series/generateSeries';
import generateTooltip from './tooltip/generateTooltip';
import generateXAxis from './xAxis/generateXAxis';
import generateYAxis from './yAxis/generateYAxis';

/**
 * Функция гля генерации настроек для графика
 */
const generateOptions = (args: IGenerateOptionsArgs) => {
    const {
        series,
        showSeriesNameInTooltipBody = false,
        showCurrentDateIndicator = false,
        columnDataLabelsEnabled = false,
        numberOfSeriesToDispaly = 4,
        showSeriesAnimation = true,
        inactiveSeriesOpacity = 1,
        xAxisType = 'datetime',
        columnsGrouping = true,
        seriesReverse = false,
        sharedTooltips = true,
        tooltipSubTitle = '',
        tooltipTitle = '',
        inverted = false,
        useUTC = false,
        timezone = '',
        columnsStacking,
        chartSettings,
        categories,
        toggleShowSharedTooltips,
        tooltipTitleFormatter,
        xAxisLabelsFormating,

        t,
    } = args;
    const MAX_COLORS = 10;

    const extendedSeries = generateSeries({
        numberOfSeriesToDispaly,
        maxColors: MAX_COLORS,
        chartSettings,
        xAxisType,
        series,
        t,
    });

    const xAxis = generateXAxis({
        highlightWeekends: chartSettings?.highlightWeekends,
        series: extendedSeries,
        showCurrentDateIndicator,
        xAxisLabelsFormating,
        categories,
        xAxisType,
        timezone,
    });
    const yAxis = generateYAxis(extendedSeries, MAX_COLORS);

    const tooltip = generateTooltip({
        showSeriesNameInTooltipBody,
        tooltipTitleFormatter,
        tooltipSubTitle,
        sharedTooltips,
        tooltipTitle,
    });

    const legend = generateLegend({
        seriesLength: extendedSeries?.length,
        maxColors: MAX_COLORS,
        seriesReverse,
    });

    const plotOptions = generatePlotOptions({
        toggleShowSharedTooltips,
        columnDataLabelsEnabled,
        inactiveSeriesOpacity,
        showSeriesAnimation,
        columnsGrouping,
        columnsStacking,
    });

    const chart = generateChart(inverted);

    return {
        ...defaultOptions,
        series: extendedSeries,
        time: { useUTC },
        plotOptions,
        tooltip,
        legend,
        chart,
        xAxis,
        yAxis,
    };
};

export default generateOptions;
